enum ModelBuilderConfigKeys {
  ActiveTab = 'activeTab',
}

enum ModelBuilderTabs {
  ModelSetup = 'Model Setup',
  Universe = 'Universe',
  TargetAverages = 'Target Averages',
  Allocation = 'Allocation',
  Diversification = 'Diversification',
}

interface ModelBuilderConfig {
  [ModelBuilderConfigKeys.ActiveTab]: ModelBuilderTabs
}

export const defaultModelBuilderConfig: ModelBuilderConfig = {
  [ModelBuilderConfigKeys.ActiveTab]: ModelBuilderTabs.ModelSetup,
}
